<div class="container-fluid" style=" background-color: #444444">
  <div class="row" >



    <div class="col-md-7" style="padding: 20px;
">

      <form style="box-shadow: 1px 0px 8px 1px black;padding: 30px">
        <h3 style="text-align: center;color: white;">Contact Me</h3>
        <div class="row" style="color: white;">
          <div class="col">
            <label>Email address *</label>
            <input type="email" class="form-control" placeholder="Enter email">
          </div>
          <div class="col">
          <label >Subject</label>
          <input type="text" class="form-control"  placeholder="Subject">
          </div></div>
        <br>
        <div class="form-group" style="color: white">
          <label >Description *</label>
          <textarea class="form-control"  rows="4"></textarea>
        </div>
        <button  type="submit" class="btn btn-outline-info" style="
padding: 10px;
    color: white;
    font-size: 16px;
border-radius: unset;
    border: 2px solid #c5c5c5;">Submit</button>
      </form>
    </div>

    <div class="col-md-5" style="padding: 50px;text-align: center;color: white" >
      <h3 style="text-align: center">Who am I ?</h3>
      <p>Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem
        Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem
        Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem
        Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem
        Lorem Lorem Lorem </p>
      <p>Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem
        Lorem Lorem  </p>
      <div class="row" style="text-align: center">

        <div class="col-md-2"></div>
        <div class="col-md-1 "> <a href="#"> <i class="fa fa-facebook"></i></a></div>
        <div class="col-md-1">
          <a href="#"> <i class="fa fa-twitter"> </i></a>
        </div>
        <div class="col-md-1">
          <a href="#"> <i class="fa fa-github"> </i></a>
        </div>
        <div class="col-md-1">
          <a href="#"> <i class="fa fa-linkedin"> </i></a>
        </div>

        <div class="col-md-1">
          <a href="#"> <i class="fa fa-phone">  </i></a>
        </div>
        <div class="col-md-1">
          <a href="#"> <i class="fa fa-envelope"> </i></a>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

  </div>

</div>



